<template>
  <div class="mb-3" style="min-height: 20rem;">
    <trek-loading :is-loading="loading">
      <div v-show="!loading">
        <table class="b2b-grid b2b-grid--collapse is-compact">
          <thead class="b2b-grid__header">
            <tr>
              <th
                v-for="header in gridColumns"
                :key="header.key"
                class="b2b-grid__cell b2b-grid__head whitespace-nowrap"
                :class="[header.cssClasses]"
                :qaid="`warranty-grid-${header.key}`"
                v-html="header.label"
              ></th>
            </tr>
          </thead>

          <tbody>
            <warranty-grid-item
              v-for="(row, index) in paginatedData"
              :key="index"
              :base-properties="baseProperties"
              :columns="columns"
              :item="row"
              @delete-claim="$emit('delete-claim', $event)"
            ></warranty-grid-item>
          </tbody>
        </table>

        <div v-if="!loading && !hasClaims" class="flex justify-center text-secondary text-md my-5">
          {{ bp('noClaimsFound') }}
        </div>

        <pagination
          v-if="gridType === 'enumClaimStatusSaved' && localPageCount > 1 && !loading"
          ref="pagination"
          :page-number="pageNumber"
          :page-count="pageCount"
          @page-change="pageChange"
          @prev-page="prevPage"
          @next-page="nextPage"
        ></pagination>
        <pagination
          v-else-if="gridType !== 'enumClaimStatusSaved' && localPageCount > 1 && !loading"
          ref="pagination"
          :page-number="gridData.paging.pageIndex"
          :page-count="gridData.paging.pageCount"
          @page-change="pageChange"
          @prev-page="prevPage"
          @next-page="nextPage"
        ></pagination>
      </div>
    </trek-loading>
  </div>
</template>

<script>
import pagination from '../../../mixins/pagination';
import remove from 'lodash/remove';
import TrekLoading from '@/components/TrekLoading';
import WarrantyGridItem from '@/components/containers/retailer/WarrantyGridItem';
import Pagination from '@/components/Pagination';

export default {
  components: {
    TrekLoading,
    Pagination,
    WarrantyGridItem,
  },
  mixins: [pagination],

  props: {
    baseProperties: {
      type: Array,
      default() {
        return [];
      },
    },
    gridData: {
      type: Object,
      default: () => {
        return {claims: []};
      },
    },
    gridType: {
      type: String,
      default: undefined,
    },
    size: {
      type: Number,
      default: 50,
    },
    loading: Boolean,
    isDetailsPageActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      columns: [],
    };
  },

  computed: {
    hasClaims() {
      return this.gridData && this.gridData.claims && this.gridData.claims.length > 0;
    },

    gridColumns() {
      if (this.gridType !== 'enumClaimStatusCompleted' && this.gridType !== 'enumClaimStatusCancelled') {
        remove(this.columns, (column) => column.key === 'orderHistory');
      }

      //details column should only show under "resolved claims" and not if warranty details toggle is off
      if (
        this.gridType !== 'enumClaimStatusCompleted' ||
        (this.gridType === 'enumClaimStatusCompleted' && !this.isDetailsPageActive)
      ) {
        remove(this.columns, (column) => column.key === 'details');
      }

      //remove orderHistory and actions column under "resolved claims" if warranty details toggle is on
      if (this.gridType === 'enumClaimStatusCompleted' && this.isDetailsPageActive) {
        remove(this.columns, (column) => column.key === 'orderHistory' || column.key === 'actions');
      }

      return this.columns;
    },

    listData() {
      return this.gridData ? this.gridData.claims : [];
    },

    localPageCount() {
      if (this.gridType === 'enumClaimStatusSaved') return this.pageCount;
      return this.gridData && this.gridData.paging ? this.gridData.paging.pageCount : 1;
    },

    paginatedData() {
      if (this.gridType === 'enumClaimStatusSaved') {
        const start = this.pageNumber * this.pageSize;
        const end = start + this.pageSize;
        return this.listData.slice(start, end);
      } else {
        return this.gridData ? this.gridData.claims : [];
      }
    },
  },

  mounted() {
    this.columns = [
      {
        label: this.getBaseProperty('claimNumber'),
        key: 'id',
      },
      {
        label: this.getBaseProperty('dateSubmitted'),
        key: 'dateCreated',
      },
      {
        label: this.getBaseProperty('poNumber'),
        key: 'poNumber',
      },
      {
        label: this.getBaseProperty('order'),
        key: 'orderHistory',
      },
      {
        label: this.getBaseProperty('status'),
        key: 'statusName',
      },
      {
        label: this.getBaseProperty('lastUpdatedBy'),
        key: 'contactName',
      },
      {
        label: this.getBaseProperty('actions'),
        key: 'actions',
      },
      {
        label: this.getBaseProperty('details'),
        key: 'details',
      },
    ];
  },

  methods: {
    pageChange(page) {
      if (page !== this.pageNumber) {
        this.pageNumber = page;
      }

      this.$emit('page-change', {gridType: this.gridType, pageNumber: this.pageNumber});
    },
  },
};
</script>
